import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import './projFullImage.css';
import { motion } from "framer-motion";
import ProgressiveBackgroundImg from "../ProgressiveBackgroundImg/ProgressiveBackgroundImg";


const ProjFullImage = ({data, content, aspectRatio, isFirstItem=false}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const { ref: inViewRef, inView: inView } = useInView({
        triggerOnce: false,
        rootMargin: "0% 0px 0% 0px", // Upper detection (30% from top)
        threshold: 0, // Element's center must be visible
    });

    const imgVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0
            }
        }, exit: {
            opacity: 0
        }
    }

    const fullVariants = {
        initial: {
            opacity: 0
        }, animate: {
            opacity: 1,
            transition: {
                duration: 1,
                delay: 0.65
            }
        }, exit: {
            opacity: 0
        }
    }

    return(
        <>
            <motion.div 
                className="proj-item_full__wrapper" 
                ref={inViewRef}
                initial={isFirstItem ? "initial" : "animate"}
                animate={"animate"}
                exit="exit"
                variants={fullVariants}
                custom={isFirstItem}
                style={{aspectRatio: aspectRatio}}
            >
                <div style={{position: "relative", width: "100%", height: "100%", overflow: "hidden"}}>
                    <img 
                        src={data.placeholder}
                        style={{
                            filter: "blur(5px)"
                        }}    
                    />
                    <motion.img 
                        initial="initial"
                        animate={isLoaded ? "animate" : "initial"}
                        exit="exit"
                        variants={imgVariants}
                        src={data.backgroundImage} 
                        onLoad={(e) => {
                            setIsLoaded(true);
                        } }
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                        }}
                    />
                </div>
                {content.heroQuote &&
                    <div className="hero_punctuator">
                        <span style={{
                            position: "relative",
                            textTransform: "uppercase",
                            paddingTop: 10,
                            color: "var(--light-unselected)",
                            fontWeight: 200,
                            fontSize: "max(10px, 0.6vw)",
                            whiteSpace: "wrap",
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center"
                        }}>{content.heroQuote[0]}
                            <span className="hero_punctuator__second">{content.heroQuote[1]}</span></span>    
                    </div>
                }
            </motion.div>
        </>
    )
}

export default ProjFullImage;